import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Accreditations } from './components/Accreditations';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { StormDamage } from './components/StormDamage';
import { Financing } from './components/Financing';
import { Reviews } from './components/Reviews';
import { ServiceArea } from './components/ServiceArea';
import { CTABand } from './components/CTABand';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white overflow-x-hidden font-sans text-tx-body selection:bg-tx-red selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Accreditations data-id="element-4" />
        <TrustBar data-id="element-5" />
        <Services data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <StormDamage data-id="element-8" />
        <Financing data-id="element-9" />
        <Reviews data-id="element-10" />
        <ServiceArea data-id="element-11" />
        <CTABand data-id="element-12" />
        <ContactForm data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}